"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInfinitePagination = exports.usePagination = void 0;
const react_1 = require("react");
const usePagination_constants_1 = require("./usePagination.constants");
const usePagination_utils_1 = require("./usePagination.utils");
const usePagination = ({ defaultPage = 1, defaultPageSize = 1, total, isCycleEnabled = false, }) => {
    const [currentPageSize, setCurrentPageSize] = (0, react_1.useState)(defaultPageSize);
    const [currentPage, setCurrentPage] = (0, react_1.useState)(defaultPage);
    const totalPages = !!total ? Math.ceil(total / currentPageSize) : 1;
    const onPageChange = (0, react_1.useCallback)(({ direction, page }) => {
        let newPage;
        if (direction) {
            const increment = direction === usePagination_constants_1.PageChangeDirection.next ? 1 : -1;
            const incrementedPage = currentPage + increment;
            const incrementOrCurrentPage = incrementedPage < 1 || incrementedPage > totalPages
                ? currentPage
                : incrementedPage;
            newPage = isCycleEnabled
                ? (0, usePagination_utils_1.cyclePointer)({
                    direction,
                    currentPointer: currentPage,
                    lastPointer: totalPages,
                })
                : incrementOrCurrentPage;
        }
        else {
            newPage = page;
        }
        setCurrentPage(newPage);
    }, [currentPage, isCycleEnabled, totalPages]);
    const onPageSizeChange = (0, react_1.useCallback)((pageSize) => {
        setCurrentPageSize(pageSize);
        // When the page size is changed, set the current page
        // to 1. Changing the page size means that the current page
        // may no longer exist or may be completely different
        setCurrentPage(1);
    }, []);
    const paginate = (0, react_1.useCallback)((list) => {
        return list.slice(...(0, usePagination_utils_1.getArraySliceArguments)({
            page: currentPage,
            pageSize: currentPageSize,
        }));
    }, [currentPage, currentPageSize]);
    const goToPage = (0, react_1.useCallback)((page) => {
        onPageChange({ page });
    }, [onPageChange]);
    const onNext = (0, react_1.useCallback)(() => {
        onPageChange({ direction: usePagination_constants_1.PageChangeDirection.next });
    }, [onPageChange]);
    const onPrevious = (0, react_1.useCallback)(() => {
        onPageChange({ direction: usePagination_constants_1.PageChangeDirection.previous });
    }, [onPageChange]);
    return {
        currentPage,
        currentPageSize,
        totalPages,
        goToPage,
        onNext,
        onPrevious,
        onPageSizeChange,
        paginate,
    };
};
exports.usePagination = usePagination;
const useInfinitePagination = ({ defaultPage = 1, defaultPageSize = 1, }) => {
    const [currentPageSize, setCurrentPageSize] = (0, react_1.useState)(defaultPageSize);
    const [currentPage, setCurrentPage] = (0, react_1.useState)(defaultPage);
    const onPageChange = (0, react_1.useCallback)(({ direction, page }) => {
        let newPage;
        if (direction) {
            const increment = direction === usePagination_constants_1.PageChangeDirection.next ? 1 : -1;
            const incrementedPage = currentPage + increment;
            newPage = incrementedPage < 1 ? currentPage : incrementedPage;
        }
        else {
            newPage = page;
        }
        setCurrentPage(newPage);
    }, [currentPage]);
    const onPageSizeChange = (0, react_1.useCallback)((pageSize) => {
        setCurrentPageSize(pageSize);
    }, []);
    const goToPage = (0, react_1.useCallback)((page) => {
        onPageChange({ page });
    }, [onPageChange]);
    const onNext = (0, react_1.useCallback)(() => {
        onPageChange({ direction: "next" });
    }, [onPageChange]);
    const onPrevious = (0, react_1.useCallback)(() => {
        onPageChange({ direction: "previous" });
    }, [onPageChange]);
    return {
        currentPage,
        currentPageSize,
        goToPage,
        onNext,
        onPrevious,
        onPageSizeChange,
    };
};
exports.useInfinitePagination = useInfinitePagination;
//# sourceMappingURL=usePagination.js.map